import {Component, OnInit} from '@angular/core';
import {Input} from '@angular/core';
import {Output} from '@angular/core';
import {EventEmitter} from '@angular/core';
import {HomeEstimatorResponse} from '../../../services/home-estimator.service';
import {HomeEstimatorRequest} from '../../../services/home-estimator.service';
import {ListingsService} from '../../../services/listings.service';
import {Pagination} from '../../../classes/pagination';
import {Filters} from '../../../classes/user-preferences';
import {Listing} from '../../../classes/listing';
import {CommunicationService} from '../../../services/communication.service';
import {HasSubscriptions} from '../../has-subscriptions';
import {SCREEN_SIZE} from '../../../classes/enums';
import {PreRenderService} from '../../../services/pre-render.service';
import MapOptions = google.maps.MapOptions;
import Map = google.maps.Map;

@Component({
  selector: 'app-home-estimator-estimate',
  templateUrl: './home-estimator-estimate.component.html',
  styleUrls: ['./home-estimator-estimate.component.scss']
})
export class HomeEstimatorEstimateComponent extends HasSubscriptions implements OnInit {
  mapEnabled: boolean;
  @Input() homeEstimate: HomeEstimatorResponse;
  @Input() standalone: boolean;
  @Input() homeEstimatorRequest: HomeEstimatorRequest;
  @Output() onContactAgent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEdit: EventEmitter<any> = new EventEmitter<any>();
  suggestedListings: Listing[];
  screenSize: SCREEN_SIZE;
  SCREEN_SIZE = SCREEN_SIZE;
  map: Map;

  calculatedEstimate: any;
  mapOptions: MapOptions = {
    zoom: 15,
    zoomControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeControl: false
  };

  constructor(private listingsService: ListingsService,
              private communicationService: CommunicationService,
              private prerenderService: PreRenderService) {
    super();
    this.mapEnabled = !this.prerenderService.isServerMode;
  }

  ngOnInit() {
    this.addSub(this.communicationService.screenSize.subscribe((screenSize) => {
      this.screenSize = screenSize;
    }));

    this.calculatedEstimate = {
      needsRepair: this.homeEstimate.marketValue * 0.95,
      wellMaintained: this.homeEstimate.marketValue * 1.05,
      showHome: this.homeEstimate.marketValue * 1.07
    }
  }

  mapReady(map) {
    this.map = map;
  }

  mapIdle(event) {
    if (this.map && this.map.getCenter()) {
      this.listingsService.getListingsByDistanceFrom(new Pagination(), new Filters(), this.map.getCenter().toJSON()).then((response) => {
        this.suggestedListings = response.results;
      });
    }
  }
}
